import { render, staticRenderFns } from "./asignar_asignaturas_a_docentes.vue?vue&type=template&id=b7aa9b96&scoped=true"
import script from "./asignar_asignaturas_a_docentes.vue?vue&type=script&lang=js"
export * from "./asignar_asignaturas_a_docentes.vue?vue&type=script&lang=js"
import style0 from "./asignar_asignaturas_a_docentes.vue?vue&type=style&index=0&id=b7aa9b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aa9b96",
  null
  
)

export default component.exports